"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bm_additional_currencies_1 = require("./bm-additional-currencies");
exports.DEFAULT_CURRENCY = 'USD';
exports.CURRENCIES = tslib_1.__assign((_a = {}, _a[bm_additional_currencies_1.Currencies.AUD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2500,
        default: 6.49,
    },
    rent: {
        min: 0.01,
        max: 2500,
        default: 3.79,
    },
    sale: {
        min: 0.01,
        max: 2500,
        default: 3.79,
    },
}, _a[bm_additional_currencies_1.Currencies.BRL] = {
    symbol: 'R$',
    offset: 2,
    subscription: {
        min: 0.05,
        max: 6500,
        default: 16.79,
    },
    rent: {
        min: 0.05,
        max: 6500,
        default: 9.79,
    },
    sale: {
        min: 0.05,
        max: 6500,
        default: 9.79,
    },
}, _a[bm_additional_currencies_1.Currencies.CAD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2500,
        default: 5.79,
    },
    rent: {
        min: 0.01,
        max: 2500,
        default: 3.49,
    },
    sale: {
        min: 0.01,
        max: 2500,
        default: 3.49,
    },
}, _a[bm_additional_currencies_1.Currencies.CHF] = {
    symbol: 'CHF',
    offset: 2,
    subscription: {
        min: 0.05,
        max: 2000,
        default: 4.99,
    },
    rent: {
        min: 0.05,
        max: 2000,
        default: 2.99,
    },
    sale: {
        min: 0.05,
        max: 2000,
        default: 2.99,
    },
}, _a[bm_additional_currencies_1.Currencies.CZK] = {
    symbol: 'Kč',
    offset: 2,
    subscription: {
        min: 1,
        max: 49000,
        default: 121.49,
    },
    rent: {
        min: 1,
        max: 49000,
        default: 72.49,
    },
    sale: {
        min: 1,
        max: 49000,
        default: 72.49,
    },
}, _a[bm_additional_currencies_1.Currencies.DKK] = {
    symbol: 'kr',
    offset: 2,
    subscription: {
        min: 0.05,
        max: 13500,
        default: 33.99,
    },
    rent: {
        min: 0.05,
        max: 13500,
        default: 19.99,
    },
    sale: {
        min: 0.05,
        max: 13500,
        default: 19.99,
    },
}, _a[bm_additional_currencies_1.Currencies.EUR] = {
    symbol: '\u20ac',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2000,
        default: 4.99,
    },
    rent: {
        min: 0.01,
        max: 2000,
        default: 2.99,
    },
    sale: {
        min: 0.01,
        max: 2000,
        default: 2.99,
    },
}, _a[bm_additional_currencies_1.Currencies.GBP] = {
    symbol: '\u00a3',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2000,
        default: 3.99,
    },
    rent: {
        min: 0.01,
        max: 2000,
        default: 2.29,
    },
    sale: {
        min: 0.01,
        max: 2000,
        default: 2.29,
    },
}, _a[bm_additional_currencies_1.Currencies.HKD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.1,
        max: 15500,
        default: 39,
    },
    rent: {
        min: 0.1,
        max: 15500,
        default: 24,
    },
    sale: {
        min: 0.1,
        max: 15500,
        default: 24,
    },
}, _a[bm_additional_currencies_1.Currencies.HUF] = {
    symbol: 'Ft',
    offset: 2,
    subscription: {
        min: 5,
        max: 570000,
        default: 1389.49,
    },
    rent: {
        min: 5,
        max: 570000,
        default: 833.49,
    },
    sale: {
        min: 5,
        max: 570000,
        default: 833.49,
    },
}, _a[bm_additional_currencies_1.Currencies.ILS] = {
    symbol: '\u20aa',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 8000,
        default: 17.9,
    },
    rent: {
        min: 0.01,
        max: 8000,
        default: 10.9,
    },
    sale: {
        min: 0.01,
        max: 8000,
        default: 10.9,
    },
}, _a[bm_additional_currencies_1.Currencies.JPY] = {
    symbol: '\u00a5',
    offset: 0,
    subscription: {
        min: 1,
        max: 250000,
        default: 420,
    },
    rent: {
        min: 1,
        max: 250000,
        default: 360,
    },
    sale: {
        min: 1,
        max: 250000,
        default: 360,
    },
}, _a[bm_additional_currencies_1.Currencies.MXN] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.5,
        max: 38000,
        default: 94.49,
    },
    rent: {
        min: 0.5,
        max: 38000,
        default: 56.49,
    },
    sale: {
        min: 0.5,
        max: 38000,
        default: 56.49,
    },
}, _a[bm_additional_currencies_1.Currencies.MYR] = {
    symbol: 'RM',
    offset: 2,
    subscription: {
        min: 0.05,
        max: 8000,
        default: 20.49,
    },
    rent: {
        min: 0.05,
        max: 8000,
        default: 12.49,
    },
    sale: {
        min: 0.05,
        max: 8000,
        default: 12.49,
    },
}, _a[bm_additional_currencies_1.Currencies.NOK] = {
    symbol: 'kr',
    offset: 2,
    subscription: {
        min: 1,
        max: 17000,
        default: 41.99,
    },
    rent: {
        min: 1,
        max: 17000,
        default: 24.99,
    },
    sale: {
        min: 1,
        max: 17000,
        default: 24.99,
    },
}, _a[bm_additional_currencies_1.Currencies.NZD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2500,
        default: 6.49,
    },
    rent: {
        min: 0.01,
        max: 2500,
        default: 3.79,
    },
    sale: {
        min: 0.01,
        max: 2500,
        default: 3.79,
    },
}, _a[bm_additional_currencies_1.Currencies.PHP] = {
    symbol: '₱',
    offset: 2,
    subscription: {
        min: 1,
        max: 94500,
        default: 233.99,
    },
    rent: {
        min: 1,
        max: 94500,
        default: 139.99,
    },
    sale: {
        min: 1,
        max: 94500,
        default: 139.99,
    },
}, _a[bm_additional_currencies_1.Currencies.PLN] = {
    symbol: 'zł',
    offset: 2,
    subscription: {
        min: 1,
        max: 8000,
        default: 19.79,
    },
    rent: {
        min: 1,
        max: 8000,
        default: 11.79,
    },
    sale: {
        min: 1,
        max: 8000,
        default: 11.79,
    },
}, _a[bm_additional_currencies_1.Currencies.RUB] = {
    symbol: '\u20bd',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 150000,
        default: 279,
    },
    rent: {
        min: 0.01,
        max: 150000,
        default: 169,
    },
    sale: {
        min: 0.01,
        max: 150000,
        default: 169,
    },
}, _a[bm_additional_currencies_1.Currencies.SEK] = {
    symbol: 'kr',
    offset: 2,
    subscription: {
        min: 1,
        max: 17000,
        default: 42.79,
    },
    rent: {
        min: 1,
        max: 17000,
        default: 25.79,
    },
    sale: {
        min: 1,
        max: 17000,
        default: 25.79,
    },
}, _a[bm_additional_currencies_1.Currencies.SGD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.05,
        max: 3000,
        default: 6.79,
    },
    rent: {
        min: 0.05,
        max: 3000,
        default: 4.79,
    },
    sale: {
        min: 0.05,
        max: 3000,
        default: 4.79,
    },
}, _a[bm_additional_currencies_1.Currencies.THB] = {
    symbol: '฿',
    offset: 2,
    subscription: {
        min: 0.5,
        max: 70000,
        default: 172.79,
    },
    rent: {
        min: 0.5,
        max: 70000,
        default: 103.49,
    },
    sale: {
        min: 0.5,
        max: 70000,
        default: 103.49,
    },
}, _a[bm_additional_currencies_1.Currencies.TWD] = {
    symbol: 'NT$',
    offset: 2,
    subscription: {
        min: 1,
        max: 65000,
        default: 158.49,
    },
    rent: {
        min: 1,
        max: 65000,
        default: 94.99,
    },
    sale: {
        min: 1,
        max: 65000,
        default: 94.99,
    },
}, _a[bm_additional_currencies_1.Currencies.USD] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 0.01,
        max: 2000,
        default: 4.99,
    },
    rent: {
        min: 0.01,
        max: 2000,
        default: 2.99,
    },
    sale: {
        min: 0.01,
        max: 2000,
        default: 2.99,
    },
}, _a[bm_additional_currencies_1.Currencies.COP] = {
    symbol: '$',
    offset: 2,
    subscription: {
        min: 1,
        max: 7000000,
        default: 1,
    },
    rent: {
        min: 1,
        max: 7000000,
        default: 1,
    },
    sale: {
        min: 1,
        max: 7000000,
        default: 1,
    },
}, _a), bm_additional_currencies_1.BM_ADDITIONAL_CURRENCIES);
//# sourceMappingURL=currencies.js.map